import React from "react";

const LoadingAnimation = () => {
  return (
    <span className="relative flex h-3 w-3 mx-auto">
      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75"></span>
      <span className="relative inline-flex rounded-full h-3 w-3 bg-sky-500"></span>
    </span>
  );
};

export default LoadingAnimation;
